
import { policyConfigResDto } from "../../modules/policy/policy.model";
import { IBaseProfile, ISIProtectDetails, kycDetailsDto } from "../../modules/profile/Account.model";
import {ActionType} from "../action-type/index";
import { IkycRes, IProfileRes, IsiRes } from "../interface/homeInterface";
interface IinitialState {
    loading:boolean,
    error:any,
    profile_Details?: IBaseProfile,
    config_Details?:policyConfigResDto,
    siprotect_Details?:ISIProtectDetails,
    kyc_Details?:Array<kycDetailsDto>,
    timeStamp:any,
    isShowModal:boolean,
    dataloaded : null
}
const initialState:IinitialState ={
    loading:false,
    error:null,
    profile_Details:{},
    config_Details:{},
    siprotect_Details:null,
    kyc_Details:null,
    timeStamp:null,    
    isShowModal:null,
    dataloaded: null
};

export const fetch_base_profile_Details_Reducer = (state:IinitialState = initialState, action:IProfileRes) => {
    switch (action.type) {
        case ActionType.FETCH_PROFILE_DETAILS_START:
            return{
                ...state,
                loading:true,
                error: null,
            }
        case ActionType.FETCH_PROFILE_DETAILS_SUCCESS:
            return {
                ...state,
                loading:false,
                profile_Details:action.profile_Details,
                timeStamp:action.timeStamp,
                isShowModal:action.isShowModal,
                dataloaded:true
            }
        case ActionType.FETCH_PROFILE_DETAILS_FAIL:
            return {
                ...state,
                loading:false,
                error:action.payload,
                dataloaded:false
            }
        default:
            return state
    }
}

export const fetch_config_Details_Reducer = (state:IinitialState = initialState, action) => {
    switch (action.type) {
        case ActionType.FETCH_CONFIG_DETAILS_START:
            return{
                ...state,
                loading:true,
                error: null,
            }
        case ActionType.FETCH_CONFIG_DETAILS_SUCCESS:
            return {
                ...state,
                loading:false,
                config_Details:action.config_Details,
                timeStamp:action.timeStamp,
            }
        case ActionType.FETCH_CONFIG_DETAILS_FAIL:
            return {
                ...state,
                loading:false,
                error:action.payload,
            }
        default:
            return state
    }
}

export const fetch_Si_Protect_Reducer = (state = initialState, action : IsiRes) => {
    switch (action.type) {
        case ActionType.FETCH_SI_PROTECT_START:
            return{
                ...state,
                loading:true,
                error: null,
            }
        case ActionType.FETCH_SI_PROTECT_SUCCESS:
            return {
                ...state,
                loading:false,
                siprotect_Details:action.siprotect_Details,
                timeStamp:action.timeStamp,
            }
        case ActionType.FETCH_SI_PROTECT_FAIL:
            return {
                ...state,
                loading:false,
                error:action.payload,
            }
        default:
            return state
    }
}
export const fetch_Kyc_Reducer = (state = initialState, action: IkycRes) => {
    switch (action.type) {
        case ActionType.FETCH_KYC_START:
            return{
                ...state,
                loading:true,
                error: null,
            }
        case ActionType.FETCH_KYC_SUCCESS:
            return {
                ...state,
                loading:false,
                kyc_Details:action.kyc_Details,
                timeStamp:action.timeStamp,
            }
        case ActionType.FETCH_KYC_FAIL:
            return {
                ...state,
                loading:false,
                error:action.payload,
            }
        default:
            return state
    }
}
export const fetch_Bank_Details_Reducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionType.FETCH_BANK_DETAIL_START:
            return{
                ...state,
                loading:true,
                error: null,
            }
        case ActionType.FETCH_BANK_DETAIL_SUCCESS:
            return {
                ...state,
                loading:false,
                data:action.data,
                timeStamp:action.timeStamp,
            }
        case ActionType.FETCH_BANK_DETAIL_FAIL:
            return {
                ...state,
                loading:false,
                error:action.payload,
            }
        default:
            return state
    }
}